import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function CalendarPicker({ currentDate, onSelect }) {
  const [calMonth, setCalMonth] = useState(() => {
    const d = new Date(currentDate + 'T00:00:00');
    return { year: d.getFullYear(), month: d.getMonth() };
  });

  const { year, month } = calMonth;
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const startPad = (firstDay.getDay() + 6) % 7;
  const totalDays = lastDay.getDate();

  const days = [];
  for (let i = startPad - 1; i >= 0; i--) {
    const d = new Date(year, month, -i);
    days.push({ date: d.toISOString().split('T')[0], cur: false, day: d.getDate() });
  }
  for (let i = 1; i <= totalDays; i++) {
    const d = new Date(year, month, i);
    days.push({ date: d.toISOString().split('T')[0], cur: true, day: i });
  }
  while (days.length % 7 !== 0) {
    const d = new Date(year, month + 1, days.length - startPad - totalDays + 1);
    days.push({ date: d.toISOString().split('T')[0], cur: false, day: d.getDate() });
  }

  const todayStr = new Date().toISOString().split('T')[0];
  const monthLabel = new Date(year, month).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  return (
    <div data-testid="calendar-picker">
      <div className="flex items-center justify-between mb-2">
        <button onClick={() => setCalMonth(p => p.month === 0 ? { year: p.year - 1, month: 11 } : { ...p, month: p.month - 1 })}
          className="p-1 hover:bg-slate-100 rounded"><ChevronLeft className="w-4 h-4 text-slate-500" /></button>
        <span className="text-sm font-semibold text-slate-700">{monthLabel}</span>
        <button onClick={() => setCalMonth(p => p.month === 11 ? { year: p.year + 1, month: 0 } : { ...p, month: p.month + 1 })}
          className="p-1 hover:bg-slate-100 rounded"><ChevronRight className="w-4 h-4 text-slate-500" /></button>
      </div>
      <div className="grid grid-cols-7 gap-0.5 text-center">
        {['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].map(d => (
          <div key={d} className="text-[9px] font-semibold text-slate-400 py-0.5">{d}</div>
        ))}
        {days.map((d, i) => {
          const isToday = d.date === todayStr;
          const isSelected = d.date === currentDate;
          return (
            <button key={i} onClick={() => onSelect(d.date)}
              className={`text-xs py-1 rounded transition-all
                ${!d.cur ? 'text-slate-300' : 'text-slate-700 hover:bg-blue-50'}
                ${isToday ? 'font-bold text-blue-600 ring-1 ring-blue-300' : ''}
                ${isSelected ? 'bg-blue-600 text-white hover:bg-blue-700' : ''}
              `}>
              {d.day}
            </button>
          );
        })}
      </div>
      <button onClick={() => onSelect(todayStr)}
        className="w-full mt-2 text-[10px] font-medium text-blue-600 hover:bg-blue-50 py-1 rounded transition-colors">
        Today
      </button>
    </div>
  );
}
